import { Component, Vue, Prop as prop } from 'nuxt-property-decorator';
import { mapState } from 'vuex';
import FsLightbox from "fslightbox-vue"

@Component({
    components: {
        rating: require('~/components/common/rating/').default,
        replyField: require('../reply-field').default,
        btn: require('~/components/form/button').default,
        customPicture: require('~/components/common/simple-picture/').default,
        FsLightbox
    },
    computed: mapState(['user'])
})
export default class ReviewMessageComponent extends Vue {

    @prop()
    public review: any;

    public showReplyField = false;
    public showRegularComments = false;
    public showPictures = false;
    public showIndex = null;
    public showLightbox = false;

    public user!: User;

    public toggleReviewField() {
        if (!this.user) {
            this.$store.commit('setLoginFormState', true);
            return;
        }
        this.showReplyField = !this.showReplyField;
    }


    get officialComments() {
        return this.review.comments.filter((el) => el.official);
    }

    get regularComments() {
        return this.review.comments.filter((el) => !el.official);
    }

    get showButtonLabel() {
        if (this.showRegularComments) {
            return 'Скрыть ответы';
        }

        if (this.regularComments.length) {
            return 'Показать все ответы';
        }

        return 'Показать ответы';
    }

    get showPicturesLabel() {

        return `${this.showPictures ? 'Скрыть' : 'Показать'} фотографии`;
    }

    get originalPhotos() {
        return this.review.photos.map((el) => `/upload${el.src}`);
    }
}
